import { createFileRoute } from "@tanstack/react-router";
import TermsPage from "@/features/public/pages/terms";

export const Route = createFileRoute("/(public)/_public/terms")({
  component: TermsPage,
});
